import { createFileRoute } from "@tanstack/react-router"
import { Legal, meta } from "@/content"

export const Route = createFileRoute("/(public)/legal/$slug")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Legal" }) }),
})

function RouteComponent() {
  const { slug } = Route.useParams()

  return <Legal slug={slug} />
}
